// import { Check, X } from 'lucide-react';
import React from 'react';
import { TableCell, TableRow } from 'src/components/ui/table';
import { pickColor } from '../../utils';
import { Client } from '../../types/client.types';

interface ManageClientsTableRowProps {
  client: Client;
  isCreation?: boolean;
  onClientSelect: (client: Client) => void;
}


const ManageClientsTableRow: React.FC<ManageClientsTableRowProps> = ({
  client,
  isCreation,
  onClientSelect,
}) => {
  const handleSelect = () => {
    // setExpanded(!expanded);
    // setClient(client);
    onClientSelect(client);
  };

  const details = () => {
    const uniquePages = [...new Set(client.permissions.map((permission) => permission.page))];
    const uniqueTabs = [...new Set(client.permissions.map((permission) => permission.tab))];
    const uniquePermissions = [...new Set(client.permissions.map((permission) => permission.permission))];

    return {
      pages: uniquePages,
      tabs: uniqueTabs,
      permissions: uniquePermissions,
    };
  };

  const uniqueAccounts = () => {
    const accounts = client.access.map((access) => access.account);
    return [...new Set(accounts)];
  };

  const uniqueCampaigns = () => {
    const campaigns = client.access.map((access) => access.campaign);
    return [...new Set(campaigns)];
  };

  const clientColor = pickColor(client.title, ['bg-green-501', 'bg-blue-500', 'bg-red-501', 'bg-yellow-500', 'bg-purple-500', 'bg-orange-500', 'bg-gray-500']);
  return (
    <>
      <TableRow
        className="border-b border-gray-201 bg-white overflow-visible sticky top-0 hover:bg-gray-201 cursor-pointer"
        onClick={handleSelect}
      >
        <TableCell className='w-[3%] min-w-[30px] py-1.5 border-r border-gray-201'>
          {/* <ChevronRight className={`h-4 w-4 text-gray-500 animate-in duration-300 ease-in-out ${expanded ? 'rotate-90' : ''}`} /> */}
        </TableCell>
        <TableCell className='border-r border-gray-201'>
          <div className='flex flex-row gap-2 items-center py-2'>
            <div className='w-8 h-8 rounded-full'>
              {client.brand && (
                <img
                  src={`${client.brand}`}
                  className='w-full h-full object-cover'
                />
              )}
              {!client.brand && <div className={`w-full h-full object-cover ${clientColor} rounded-full`} />}
            </div>
            <div className='text-sm font-bold flex flex-col'>
              <div className='text-sm font-bold'>
                {client.title}
              </div>
              <div className='!text-xs font-normal text-gray-500'>
                {client.companies && client.companies.map((company) => company.company_name).join(', ')}
              </div>
            </div>
          </div>
        </TableCell>
        <TableCell className='border-r border-gray-201'>
          <div className='text-sm'>
            {client.users.length}
            {' '}
            Users
          </div>
        </TableCell>
        <TableCell className='border-r border-gray-201'>
          <div className='text-sm'>
            {uniqueAccounts().length}
            {' '}
            Acccounts
          </div>
        </TableCell>
        <TableCell className='border-r border-gray-201'>
          <div className='text-sm'>
            {uniqueCampaigns().length}
            {' '}
            Campaigns
          </div>
        </TableCell>
        <TableCell>
          <div className='text-xs'>
            {details().tabs.map((tab) => tab.toUpperCase()?.replace('_', ' ')).join(', ')}
          </div>
          <div className='text-xs'>
            {details().permissions.filter((permission) => permission !== null).map((permission) => permission?.toUpperCase()?.replace('_', ' ')).join(', ')}
          </div>
        </TableCell>
      </TableRow>
    </>
  );
};

export default ManageClientsTableRow;
